<div
  [ngClass]="{ overlay: isSidebarActive }"
  class="shell layout-wrapper"
>
  @if (hasAside) {
    <aside class="side-nav">
      <ncp-aside />
    </aside>
  }
  <main
    class="main"
    [class.d-flex]="router.url.match(`^\/eu\/[a-z]{2}\/patient$`) || router.url === '/cy/patient' || router.url === '/cy' || router.url === '/' || !profile"
    [class.flex-column]="router.url.match(`^\/eu\/[a-z]{2}\/patient$`) || router.url === '/cy/patient' || router.url === '/cy' || router.url === '/' || !profile"
  >
    <ncplib-header
      [callback]="modCallback()"
      [environment]="environment.project?.toString()"
      [breadcrumb]="isLoggedIn && profile && router.url != '/' && router.url != '/support' ? BreadcrumbComponent : undefined"
    />
    <div
      class="content"
      [class.d-flex]="router.url === '/cy/patient' || router.url === '/cy' || router.url === '/' || !profile"
      [class.flex-grow-1]="router.url === '/cy/patient' || router.url === '/cy' || router.url === '/' || !profile"
      [class.justify-content-center]="
      router.url === '/cy' ||
      router.url === '/support' ||
      (router.url === '/' && environment.project === PROJECTS.PROVIDERS && !_isLoggedIn()) ||
      (router.url === '/' && environment.project === PROJECTS.BENEFICIARIES && !_isLoggedIn())"
    >
      <router-outlet></router-outlet>
    </div>
  </main>
  <ncplib-footer [isLoggedIn]="_isLoggedIn()"></ncplib-footer>
</div>

<span class="toast-container position-fixed top-0 end-0 p-3 z-3">
  @for (toast of toastService.toasts(); track toast.id) {
    <ncp-toast [options]="toast"></ncp-toast>
  }
</span>

<ncp-modal
  #modal
  [options]="modOptions()"
>
  @if(isLoggedIn && profile && environment.project === PROJECTS.PROVIDERS) {
    <div class="d-flex flex-column">

      <div class="row">

        <div class="col-lg-6 col-12 mb-3">
          <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.name }}
              </span>
            <span class="col-7">
                {{ profile.given_name }}
              </span>
          </div>
        </div>

        <div class="col-lg-6 col-12 mb-3">
          <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.surname }}
              </span>
            <span class="col-7">
                {{ profile.family_name }}
              </span>
          </div>
        </div>

        <div class="col-lg-6 col-12 mb-3">
          <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.medical_registry_id }}
              </span>
            <span class="col-7">
                {{ profile.RegistrationNumber }}
              </span>
          </div>
        </div>

        <div class="col-lg-6 col-12 mb-3">
          <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.professional_title }}
              </span>
            <span class="col-7">
                {{ capitalizeFirstLetter(profile.role) }}
              </span>
          </div>
        </div>

        <div class="col-lg-6 col-12 mb-3">
          <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.phone }}
              </span>
            <span class="col-7">
                {{ profile.phone_number }}
              </span>
          </div>
        </div>

        <div class="col-lg-6 col-12 mb-3">
          <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.email }}
              </span>
            <span class="col-7">
                {{ profile.email }}
              </span>
          </div>
        </div>

        @if(profile.role === Roles.physician) {
          <div class="col-lg-6 col-12 mb-3">
            <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.address }}
              </span>
              <span class="col-7">
                {{ profile.Address1 + ' ' + profile.City + ', ' + profile.Country }}
              </span>
            </div>
          </div>

          <div class="col-lg-6 col-12 mb-3">
            <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.specialty_1 }}
              </span>
              <span class="col-7">
                {{ profile.Specialty1 }}
              </span>
            </div>
          </div>

          <div class="col-lg-6 col-12 mb-3">
            <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.specialty_2 }}
              </span>
              <span class="col-7">
                {{ profile.Specialty2 }}
              </span>
            </div>
          </div>

          <div class="col-lg-6 col-12 mb-3">
            <div class="row">
              <span class="col-5 fw-bolder">
                {{ translations.profile.specialty_3 }}
              </span>
              <span class="col-7">
                {{ profile.Specialty3 }}
              </span>
            </div>
          </div>
        }

      </div>
    </div>
  }
</ncp-modal>
